import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatList',
  standalone: true
})
export class FormatListPipe implements PipeTransform {

  transform(items: string[] | null | undefined): string {
    if (!items || items.length === 0) return '';

    // Add "operation " prefix to each item
    const labeledItems = items.map(item => `Operation ${item}`);

    if (labeledItems.length === 1) return labeledItems[0];
    if (labeledItems.length === 2) return `${labeledItems[0]} and ${labeledItems[1]}`;

    // 3+ items: "a, b, c, and d"
    const last = labeledItems[labeledItems.length - 1];
    const rest = labeledItems.slice(0, -1);
    return `${rest.join(', ')} and ${last}`;
  }

}
